import React from 'react';
import { MassDuplicateProducts } from "../components/product/mass-duplicate-products/mass-duplicate-products"


const MassDuplicateProductsPage = () => {
	return (
		<MassDuplicateProducts />
	)
}

export default MassDuplicateProductsPage;


// WEBPACK FOOTER //
// ./src/containers/mass-duplicate-products-page.js